<template>
    <v-flex xs12>
        <v-card class="elevation-0 pa-5" flat>
            <h1 class="fonte text-uppercase">Pedidos</h1>
            <v-layout wrap row grid pt-3>
                <v-flex xs12 sm5 md6>
                    <v-menu v-model="menuPicker" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="date1" label="Data Inicial" color="fundo"  readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker locale="pt-br" v-model="date1" @input="menuPicker = false" color="fundo"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md5 class="ml-2">
                    <v-menu v-model="menuPicker2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="date2" label="Data Final"  color="fundo" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker locale="pt-br" v-model="date2" @input="menuPicker2 = false" color="fundo"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12 sm5 md6>
                    <v-autocomplete v-model="codigo" :items="dadosPedidosSemFiltro.pedidos"  item-text="hash" item-value="hash" color="teal" hide-no-data hide-selected
                        label="Código Pedido" placeholder="Código do Pedido"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md5 class="ml-2">
                    <v-autocomplete v-model="telefone" :items="dadosPedidosSemFiltro.pedidos"  item-text="telefone.telefone" item-value="telefone._id" color="fundo" hide-no-data hide-selected
                        label="Telefone" placeholder="Telefone" ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md2>
                    <v-btn :loading="loading"  color="fundo" large round @click="search">
                        <v-icon left>
                            search
                        </v-icon>
                        Pesquisar
                        <template v-slot:loader>
                            <span class="custom-loader">
                                <v-icon light>cached</v-icon>
                            </span>
                        </template>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card>
        <v-divider ></v-divider>
        <v-card flat class="mb-3 pb-3">
            <v-flex xs12 >
                <v-data-table :headers="headers" :items="dadosPedidos.pedidos"  no-data-text="Sem resultados" class="elevation-1" hide-actions>
                    <template v-slot:items="props">
                        <td >{{ props.item.hash }}</td>
                        <td>{{ props.item.status }}</td>
                        <td >{{ format(props.item.createdAt) }}</td>
                        <td >{{ props.item.status === 'concluido' ? format(props.item.updateAt): '-' }}</td>
                        <td >{{ props.item.telefone.telefone }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-card>
    </v-flex>
</template>
<script>
import CTable from '../../CTable'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
    components:{
        CTable,
    },

   data: () => ({
        loading: false,
        codigo:null,
        telefone:null,
        menuPicker      : false,
        menuPicker2     : false,
        date1           : "",//new Date().toISOString().substr(0, 10),
        date2           : "",//new Date().toISOString().substr(0, 10),
       headers: [
          {text: 'Código', value: 'hash'},
          { text: 'Status', value: 'status' },
          { text: 'Data Criação', value: 'createdAt' },
          { text: 'Data Concluido', value: 'dt_criacao' },
          { text: 'Telefone', value: 'telefone' },
        ],
        dadosPedidosSemFiltro: [],
        dadosPedidos:[],
    }),

    async mounted() {
        await this.loadUserLocal()
        await this.isClientQueroTaxi(this.getUserLocal.key)

        if(this.system.empresaQueroTaxi && this.system.empresaQueroTaxi._id) {
            this.dadosPedidos = await this.loadPedidosQueroTaxi({empresa_id: this.system.empresaQueroTaxi._id})
            this.dadosPedidosSemFiltro = this.dadosPedidos
        }
    },

    methods: {
        ...mapActions(['loadPedidosQueroTaxi', 'loadUserLocal', 'isClientQueroTaxi']),

         format(date) {
            moment.locale("pt-br");
            return moment(date).format('LLLL');
        },
        async search(){
            this.loading = true

            const params = {}
            this.date1    && ( params.dt_ini = new Date(this.date1).toISOString().substr(0, 10))
            this.date2    && ( params.dt_fim = new Date(this.date2).toISOString().substr(0, 10))
            this.telefone && ( params.telefone = this.telefone )
            this.codigo   && ( params.hash = this.codigo )

            this.dadosPedidos = await this.loadPedidosQueroTaxi({
                empresa_id: this.system.empresaQueroTaxi._id,
                params
            })

            this.date1 = ''
            this.date2 = ''
            this.telefone = ''
            this.codigo = ''

            this.loading = false
        }
    },

    computed: {
        ...mapState(['system']),
        ...mapGetters(['getUserLocal'])
    },
    watch: {
        modalSemDados (val) {
            if (!val) return
            setTimeout(() => (this.modalSemDados = false), 4000)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/QueroTaxi/ListarPedidos.vue